import { render, staticRenderFns } from "./Map-5-transoxiana.vue?vue&type=template&id=912d13ee&"
import script from "./Map-5-transoxiana.vue?vue&type=script&lang=js&"
export * from "./Map-5-transoxiana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports